/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_displayInfo = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_displayInfo" | "PdpRespSidebarContact_displayInfo" | "PdpSharedPromoCode_displayInfo" | "PdpRespSidebarBlurbs_displayInfo">;
    readonly " $refType": "PdpRespContainer_displayInfo";
};
export type PdpRespContainer_displayInfo$data = PdpRespContainer_displayInfo;
export type PdpRespContainer_displayInfo$key = {
    readonly " $data"?: PdpRespContainer_displayInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_displayInfo">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_displayInfo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_displayInfo"
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};
(node as any).hash = 'dc7474bb2c5621cc075920bafd6a56bd';
export default node;
